import React, { useState } from 'react';
import { BsGithub, BsLinkedin } from 'react-icons/bs';
import { FiArrowUpRight } from 'react-icons/fi';

import { AppWrap, MotionWrap } from '../../wrapper';
import { client } from '../../client';
import './Footer.scss';

const initialFormData = { username: '', email: '', message: '' };

const Footer = () => {
  const [formData, setFormData] = useState(initialFormData);
  const [isFormSubmitted, setIsFormSubmitted] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleChangeInput = (event) => {
    const { name, value } = event.target;
    setFormData((current) => ({ ...current, [name]: value }));
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    setLoading(true);
    setError('');

    const contact = {
      _type: 'contact',
      name: formData.username,
      email: formData.email,
      message: formData.message,
    };

    client.create(contact)
      .then(() => {
        setLoading(false);
        setIsFormSubmitted(true);
        setFormData(initialFormData);
      })
      .catch(() => {
        setLoading(false);
        setError('The message could not be sent. Please email me directly instead.');
      });
  };

  return (
    <>
      <div className="contact-intro">
        <p className="eyebrow">07 / Contact</p>
        <h2>Have a research question or software challenge?</h2>
        <a href="mailto:aminul.csebu@gmail.com">
          Let&apos;s explore it <FiArrowUpRight />
        </a>
      </div>

      <div className="contact-layout">
        <aside className="contact-details">
          <div>
            <p className="contact-label">Email</p>
            <a href="mailto:aminul.csebu@gmail.com">aminul.csebu@gmail.com</a>
          </div>
          <div>
            <p className="contact-label">Phone</p>
            <a href="tel:+8801701035745">+880 1701-035745</a>
          </div>
          <div>
            <p className="contact-label">Find me</p>
            <div className="contact-socials">
              <a href="https://github.com/knowaminul" target="_blank" rel="noreferrer">
                <BsGithub /> GitHub
              </a>
              <a href="https://www.linkedin.com/in/knowaminul/" target="_blank" rel="noreferrer">
                <BsLinkedin /> LinkedIn
              </a>
            </div>
          </div>
          <p className="contact-note">
            Based in Dhaka, Bangladesh. Open to research collaborations, graduate
            opportunities, and thoughtful software work across time zones.
          </p>
        </aside>

        <div className="contact-form-wrap">
          {!isFormSubmitted ? (
            <form className="app__footer-form" onSubmit={handleSubmit}>
              <div className="form-field">
                <label htmlFor="contact-name">Your name</label>
                <input
                  id="contact-name"
                  type="text"
                  placeholder="Jane Smith"
                  name="username"
                  value={formData.username}
                  onChange={handleChangeInput}
                  autoComplete="name"
                  required
                />
              </div>
              <div className="form-field">
                <label htmlFor="contact-email">Email address</label>
                <input
                  id="contact-email"
                  type="email"
                  placeholder="jane@company.com"
                  name="email"
                  value={formData.email}
                  onChange={handleChangeInput}
                  autoComplete="email"
                  required
                />
              </div>
              <div className="form-field">
                <label htmlFor="contact-message">What can I help with?</label>
                <textarea
                  id="contact-message"
                  placeholder="A little about your project, role, or idea..."
                  value={formData.message}
                  name="message"
                  onChange={handleChangeInput}
                  required
                />
              </div>
              {error && <p className="form-error" role="alert">{error}</p>}
              <button type="submit" disabled={loading}>
                {loading ? 'Sending…' : 'Send message'} <FiArrowUpRight />
              </button>
            </form>
          ) : (
            <div className="form-success" role="status">
              <span>✓</span>
              <h3>Message received.</h3>
              <p>Thanks for reaching out. I&apos;ll get back to you soon.</p>
              <button type="button" onClick={() => setIsFormSubmitted(false)}>Send another</button>
            </div>
          )}
        </div>
      </div>

      <footer className="site-footer">
        <p>© 2026 knowaminul</p>
        <p>Designed &amp; developed with care.</p>
        <a href="#home">Back to top ↑</a>
      </footer>
    </>
  );
};

export default AppWrap(
  MotionWrap(Footer, 'app__footer'),
  'contact',
  'app__primarybg',
);
